import { CollectionsPage } from '../collectionsPage';

// Get all the collections whose handles are in the collections array
// Find all meta tags with the itemprop attribute set to collection-handle
let collectionHandles = Array.from(document.querySelectorAll('meta[itemprop="collection-handle"]')).map((meta) => meta.getAttribute('value')).filter((value): value is string => value !== null);
if(collectionHandles.length === 0){
  collectionHandles = ["island-time", "island-time", "island-time", "island-time", "island-time"];
}

window.addEventListener('DOMContentLoaded', async () => {
  const collectionsPage = new CollectionsPage();
  const collectionsPromises = collectionsPage.getCollectionsByHandles(collectionHandles);
  collectionsPage.setupPage(collectionsPromises);
});
